import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ContactModal from './ContactModal';

const Contact = ({ email }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section id="contact" className="relative py-8 md:py-12 lg:py-16 px-4 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 glass opacity-90"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-10 right-10 w-96 h-96 bg-white/20 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-white/10 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center space-y-6 md:space-y-8">
          {/* Icon and badge */}
          <div className="glass inline px-4 py-2 rounded-full border border-purple-500/30 hover:border-purple-400/60 transition-all duration-300">
            💬 Let's Connect
          </div>

          {/* Main heading */}
          <div className="space-y-4">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black gradient-text leading-tight">
              Ready to Start a Project?
            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              I'm always interested in hearing about new projects and opportunities. Let's create something amazing together!
            </p>
          </div>

          {/* CTA Button */}
          <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="inline-block pt-4 md:pt-8"
          >
            <motion.button
              onClick={() => setIsModalOpen(true)}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className={`inline-flex items-center gap-3 btn-primary ${
                isHovered ? 'scale-110' : 'scale-100'
              }`}
            >
              <span className={`transition-transform duration-300 text-2xl ${isHovered ? 'animate-bounce' : ''}`}>
                📧
              </span>
              Get In Touch
              <span className={`transition-transform duration-300 text-xl ${isHovered ? 'translate-x-2' : ''}`}>
                →
              </span>
            </motion.button>
          </div>

          {/* Contact Modal */}
          <ContactModal 
            isOpen={isModalOpen} 
            onClose={() => setIsModalOpen(false)} 
            email={email}
          />

          {/* Alternative contact methods */}
          <div className="pt-8 md:pt-12 border-t border-purple-500/20">
            <p className="text-purple-300 text-sm md:text-base mb-6 font-semibold">Other ways to reach me:</p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 md:gap-8">
              <a
                href={`mailto:${email}`}
                className="text-gray-300 hover:text-purple-300 font-bold transition-all duration-300 flex items-center gap-2 justify-center group transform hover:scale-110"
              >
                <span className="text-2xl group-hover:scale-125 transition-transform duration-300">✉️</span>
                Email
              </a>
              <a
                href="https://wa.me/8801998787793"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-purple-300 font-bold transition-all duration-300 flex items-center gap-2 justify-center group transform hover:scale-110"
              >
                <span className="text-2xl group-hover:scale-125 transition-transform duration-300">💬</span>
                WhatsApp
              </a>
              <a
                href="https://github.com/Sarwar009"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-purple-300 font-bold transition-all duration-300 flex items-center gap-2 justify-center group transform hover:scale-110"
              >
                <span className="text-2xl group-hover:scale-125 transition-transform duration-300">🐙</span>
                GitHub
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;